module.exports = __webpack_public_path__ + "img/img_sign.001ebcf4.png";